import { Stack } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import Text from 'components/_core/Text';

import { useCreateMerchantAccountMutation } from '../../hooks/useCreateMerchantAccountMutation';
import locales from './locales';

export const EmptyState = () => {
  const [createCompanyPaymentProviderAccount, { error, loading }] =
    useCreateMerchantAccountMutation();

  return (
    <Stack alignItems="start" gap="space-8">
      <Text>{locales.noStripeAccount}</Text>

      <Button isLoading={loading} onClick={createCompanyPaymentProviderAccount}>
        {locales.createStripeAccount}
      </Button>

      {error ? <Text variant="danger">{error.message}</Text> : null}
    </Stack>
  );
};
